import { FormEvent, useEffect, useState } from "react";
import { useParams } from "@tanstack/react-router";
import { Badge, Button, Card, PageHeader } from "@/components/primitives";
import { CosmosActionState, useCosmosClient } from "@/lib/cosmos-api";

export function ActionDetailPage() {
  const { requestId } = useParams({ from: "/actions/$requestId" });
  const cosmos = useCosmosClient();
  const [action, setAction] = useState<CosmosActionState | null>(null);
  const [approvalToken, setApprovalToken] = useState("");
  const [reason, setReason] = useState("");
  const [error, setError] = useState<string | null>(null);

  const load = async () => {
    setAction(await cosmos.actionStatus(requestId));
  };

  useEffect(() => {
    void load().catch((err) =>
      setError(err instanceof Error ? err.message : "Failed to load action")
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestId]);

  const decide = async (event: FormEvent, decision: "approve" | "reject") => {
    event.preventDefault();
    setError(null);
    try {
      setAction(
        await cosmos.decideAction(requestId, {
          decision,
          approvalToken,
          reason: reason || undefined
        })
      );
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to decide action");
    }
  };

  return (
    <div className="page">
      <PageHeader
        eyebrow="Action"
        title={action?.actionType ?? requestId}
        subtitle="Review payload and approve or reject the request."
        actions={action && <Badge tone="warning">{action.status}</Badge>}
      />
      {error && <Card className="error-card">{error}</Card>}
      {action && (
        <>
          <Card>
            <pre>{JSON.stringify(action, null, 2)}</pre>
          </Card>
          {action.status === "pending_approval" && (
            <Card>
              <form className="decision-form">
                <input
                  value={approvalToken}
                  onChange={(event) => setApprovalToken(event.target.value)}
                  placeholder="Approval token"
                />
                <input
                  value={reason}
                  onChange={(event) => setReason(event.target.value)}
                  placeholder="Reason (optional)"
                />
                <div className="inline-list">
                  <Button onClick={(event) => void decide(event, "approve")}>
                    Approve
                  </Button>
                  <Button variant="secondary" onClick={(event) => void decide(event, "reject")}>
                    Reject
                  </Button>
                </div>
              </form>
            </Card>
          )}
        </>
      )}
    </div>
  );
}
